import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "./components/header";
import Navbar from "./components/navbar";
import MainContent from "./components/mainContent";
import Footer from "./components/footer";
import Ministers from "./components/ministers";
import MinisterNew from "./components/ministerNew";
import GujaratMap from "./components/gujratMap";
import PdfAccordion from "./components/pdfAccordion";
import GovtLogoCarousel from "./components/govtLogoCarousel";
import GalleryCarousel from "./components/Gallery";
import TotalData from "./components/TotalData";
import { getHomeData,getHomeImages } from "../../../feature-module/auth/services/apiCalling";
import { useDispatch, useSelector } from "react-redux";

const ApmcHomePage = () => {
  const [fontSize, setFontSize] = useState(100);
  const [highContrast, setHighContrast] = useState(false);
  const [hlanguage, setHlanguage] = useState<any[]>([]);
  const [navbarLanguage, setNavbarLanguage] = useState(() => {
    // Get saved language from localStorage or default to "homeEn"
    return localStorage.getItem("selectedLanguage") || "homeEn";
  });
  const [allImagesLink, setAllImagesLink] = useState<Record<string, any>>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const base_Url = process.env.REACT_APP_BASE_URL;

  const fetchAnnouncements = async (navLang) => {
    try {
      setLoading(true);
      const response = await getHomeData(navLang);

      if (response?.data?.success && response?.data?.data) {
        setHlanguage(response.data.data);
        // dispatch(setHomeLanguage(response.data.data));
        setError(null);
      } else {
        const errorMsg = "Failed to load Data";
        setError(errorMsg);
        toast.error(errorMsg, { position: "top-right", autoClose: 3000});
      }
    } catch (err) {
      const errorMsg = "Failed to load Data";
      setError(errorMsg);
      toast.error(errorMsg, { position: "top-right", autoClose: 3000});
    } finally {
      setLoading(false);
    }
  };
  const fetchImages = async ()=> {
    try {
      const response = await getHomeImages();
      if (response?.data?.success && response?.data?.data) {
        setAllImagesLink(response?.data?.data)
      } else {
        toast.error("Failed to load Data", { position: "top-right", autoClose: 3000});
      }
    } catch (err) {
      toast.error("Failed to load Data", { position: "top-right", autoClose: 3000});
    }
  };

  //Local Storage for Language
useEffect(() => {
  const initializeData = async () => {
    await Promise.all([
      fetchAnnouncements(navbarLanguage),
      fetchImages()
    ]);
    localStorage.setItem("selectedLanguage", navbarLanguage);
  };
  
  initializeData();
}, [navbarLanguage]);
   

  return (
    <>
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <style>{`
        @media (max-width: 576px) {
          body {
            overflow-x: hidden;
          }
          
          .container-fluid {
            padding-left: 0;
            padding-right: 0;
          }
        }

        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          backdrop-filter: blur(5px);
        }

        .loader-spinner {
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top: 4px solid white;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .content-wrapper {
          transition: filter 0.3s ease;
        }

        .content-wrapper.blur {
          filter: blur(3px);
          pointer-events: none;
        }
      `}</style>

      <div
        style={{ fontSize: `${fontSize}%`, }}
        className={`${highContrast ? "bg-dark text-white" : ""} w-100`}
      >
        {/* Loader Overlay */}
        {loading && (
          <div className="loader-overlay">
            <div className="loader-spinner"></div>
          </div>
        )}

        {/* Content with blur effect when loading */}
        <div className={`content-wrapper ${loading ? "blur" : ""}`}>
          {/* Header component */}
          {allImagesLink && <Header hlanguage={hlanguage} allImagesLink={allImagesLink}/>}

          {/* Navbar component */}
          <Navbar hlanguage={hlanguage} setNavbarLanguage={setNavbarLanguage}/>

          {/* Main content */}
          {allImagesLink && <MainContent allImagesLink={allImagesLink} hlanguage={hlanguage} />}

          {/* <Ministers /> */}
          <div>
            <MinisterNew hlanguage={hlanguage} />
          </div>
    
          <GujaratMap hlanguage={hlanguage} />
          <div id="gallery" className="mb-3">

          </div>
         <div >
           {allImagesLink && <GalleryCarousel allImagesLink={allImagesLink} hlanguage={hlanguage} /> }
         </div>
          <PdfAccordion hlanguage={hlanguage} />
          {allImagesLink && <GovtLogoCarousel allImagesLink={allImagesLink}  hlanguage={hlanguage} />}
          {allImagesLink && <Footer allImagesLink={allImagesLink} hlanguage={hlanguage} />}       {/* Footer component */}
        </div>
      </div>
    </>
  );
};

export default ApmcHomePage;